import React, { useEffect, useState } from 'react';
import { fetchAPI } from 'shared/api';

export default function MenuManagement({ token, restaurantId }) {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  // Form state
  const [form, setForm] = useState({
    name: '',
    price: '',
    description: '',
    is_active: true,
    cuisine_type_id: '',
  });

  // Fetch menu items
  useEffect(() => {
    if (!restaurantId) return;
    setLoading(true);
    fetchAPI(`/menu/${restaurantId}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(setMenu)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [token, restaurantId, showForm]);

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) {
        await fetchAPI(`/menu/item/${editItem.id}`, {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(form),
        });
      } else {
        await fetchAPI('/menu', {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...form,
            restaurant_staging_id: restaurantId
            // idempotency_key: crypto.randomUUID(),
          }),
        });
      }
      setShowForm(false);
      setEditItem(null);
      setForm({ name: '', price: '', description: '', is_active: true, cuisine_type_id: '' });
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle edit
  const handleEdit = (item) => {
    setEditItem(item);
    setForm({
      name: item.name || '',
      price: item.price || '',
      description: item.description || '',
      is_active: item.is_active,
      cuisine_type_id: item.cuisine_type_id || '',
    });
    setShowForm(true);
  };

  // Render
  return (
    <div className="max-w-2xl mx-auto p-4 bg-white shadow-md rounded">
      <h2 className="text-2xl font-bold mb-4">Menu Management</h2>
      {error && <div className="text-red-500 mb-2">{error}</div>}
      {loading ? (
        <div>Loading menu...</div>
      ) : (
        <>
          <button className="mb-4 bg-blue-500 text-white px-4 py-2 rounded" onClick={() => { setShowForm(true); setEditItem(null); }}>Add Menu Item</button>
          <table className="w-full mb-4">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Description</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {menu.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.price}</td>
                  <td>{item.description}</td>
                  <td>{item.is_active ? 'Active' : 'Inactive'}</td>
                  <td>
                    <button className="text-blue-600 mr-2" onClick={() => handleEdit(item)}>Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {showForm && (
        <form onSubmit={handleSubmit} className="mb-4">
          <div className="mb-2">
            <label>Name</label>
            <input className="w-full border p-2" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
          </div>
          <div className="mb-2">
            <label>Price</label>
            <input className="w-full border p-2" type="number" step="0.01" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} required />
          </div>
          <div className="mb-2">
            <label>Description</label>
            <input className="w-full border p-2" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
          </div>
          <div className="mb-2">
            <label>Status</label>
            <select className="w-full border p-2" value={form.is_active ? 'active' : 'inactive'} onChange={e => setForm(f => ({ ...f, is_active: e.target.value === 'active' }))}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="mb-2">
            <label>Cuisine Type ID</label>
            <input className="w-full border p-2" type="number" value={form.cuisine_type_id} onChange={e => setForm(f => ({ ...f, cuisine_type_id: e.target.value }))} />
          </div>
          <div className="flex gap-2">
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">{editItem ? 'Update' : 'Add'} Item</button>
            <button type="button" className="bg-gray-400 text-white px-4 py-2 rounded" onClick={() => { setShowForm(false); setEditItem(null); setForm({ name: '', price: '', description: '', is_active: true, cuisine_type_id: '' }); }}>Cancel</button>
          </div>
        </form>
      )}
    </div>
  );
}
